import React, { useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  BulkImportGroupAccount,
  StoreGroupAccount
} from "../../../api/masters/groupAccountAPI";
import BulkImport from "../../../components/BulkImport";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  underGroup: yup.string().required("Under Group is required"),
  nature: yup.string().optional()
});

const AddGroupAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreGroupAccount(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/masters/group-account/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  const bulkColumns = [
    { key: "name", label: "Name", sample: "Name" },
    { key: "underGroup", label: "Under Group", sample: "Under Group" },
    { key: "nature", label: "Nature", sample: "Nature" }
  ];

  const handleBulkImport = async payload => {
    const response = await BulkImportGroupAccount(payload);

    if (response.success) {
      showToast("success", response.message);
      navigate("/masters/group-account/list");
    } else {
      showToast("error", response.message);
    }
  };

  return (
    <Fragment>
      <Breadcrumb parent="Group Account" title="Add Group Account" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Add Group Account</h5>
                  <Link to={`/masters/group-account/list`}>
                    <button className="btn btn-primary" id="list">
                      List Group Account
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Group Account
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Name *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Under Group *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Under Group"
                          {...register("underGroup")}
                        />
                        {errors.underGroup &&
                          <p className="text-danger">
                            {errors.underGroup.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="nature">Nature</label>
                        <select
                          className="form-control"
                          id="nature"
                          type="text"
                          placeholder="Nature"
                          {...register("nature")}
                        >
                          <option value="">Select Nature</option>
                          <option value="Bank">Bank</option>
                          <option value="Cash">Cash</option>
                          <option value="Customer">Customer</option>
                          <option value="Others">Others</option>
                          <option value="Purchase">Purchase</option>
                          <option value="Revenue">Revenue</option>
                          <option value="Sale">Sale</option>
                          <option value="Supplier">Supplier</option>
                          <option value="Unsecured Loan">Unsecured Loan</option>
                          <option value="Expenditure">Expenditure</option>
                          <option value="Asset">Asset</option>
                        </select>
                        {errors.nature &&
                          <p className="text-danger">
                            {errors.nature.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <BulkImport
              columns={bulkColumns}
              onSubmit={handleBulkImport}
              payloadKey="groupAccounts"
              sampleFileName="groupAccount_sample.csv"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddGroupAccount;
